import { Controller } from "@hotwired/stimulus"
import ga from "../utils/ga"

export default class extends Controller {
  static get targets() {
    return ["item"]
  }

  static values = {
    additionalParams: Object,
  }

  connect() {
    if (this.itemTargets.length > 0) {
      this.itemTargets.forEach((item) => this.trackImpression(item))
      ga("send", "event", "Ecommerce", "view", "Product impression", {
        nonInteraction: true,
        ...this.additionalParamsValue,
      })
    }
  }

  trackImpression(item) {
    ga("ec:addImpression", this.impressionData(item))
  }

  impressionData(item) {
    const impressionData = {
      id: parseInt(item.dataset.itemId),
      position: parseInt(item.dataset.impressionPosition),
      name: item.dataset.impressionName,
      list: item.dataset.impressionList,
      brand: item.dataset.impressionBrand,
    }

    const impressionCategory = item.dataset.impressionCategory
    impressionCategory && (impressionData.category = impressionCategory)
    return impressionData
  }
}
